<script lang="ts" setup>
import ListItem from './PageHeaderListItem.vue';
import ResourceTools from './ResourceTools.vue';
</script>

<template>
  <ul class="m-0 flex list-none justify-between px-0 py-32">
    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">{{ $t('header.project.content1.title') }}</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem :title="$t('header.project.content1.item4.title')" to="/projects#graduation">
            <template #icon>
              <img data-src="@/home/assets/header/project-all-1.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content1.item1.title')" to="/projects#incubation">
            <template #icon>
              <img data-src="@/home/assets/header/project-all-2.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content1.item2.title')" to="/projects#preparatory">
            <template #icon>
              <img data-src="@/home/assets/header/project-all-3.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content1.item3.title')" to="/projects#archived">
            <template #icon>
              <img data-src="@/home/assets/header/project-all-4.svg" alt="" class="lazyload size-24">
            </template>
          </ListItem>
        </li>
      </ul>
    </li>

    <li class="flex flex-col gap-y-16">
      <div class="text-14 color-#A1A1A1 font-400 leading-17">{{ $t('header.project.content2.title') }}</div>
      <ul class="m-0 w-331 list-none p-0">
        <li>
          <ListItem :title="$t('header.project.content2.item1.title')" :description="$t('header.project.content2.item1.desc')" href="https://www.openharmony.cn/">
            <template #icon>
              <img data-src="@/home/assets/header/project-star-1.png" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content2.item2.title')" :description="$t('header.project.content2.item2.desc')" href="https://www.openeuler.openatom.cn/">
            <template #icon>
              <img data-src="@/home/assets/header/project-star-2.svg" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content2.item3.title')" :description="$t('header.project.content2.item3.desc')" href="https://www.openkylin.top/">
            <template #icon>
              <img data-src="@/home/assets/header/project-star-3.png" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
        <li>
          <ListItem :title="$t('header.project.content2.item4.title')" :description="$t('header.project.content2.item4.desc')" href="https://www.opentenbase.org/">
            <template #icon>
              <img data-src="@/home/assets/header/project-star-4.png" alt="" class="lazyload size-24 object-contain">
            </template>
          </ListItem>
        </li>
      </ul>
    </li>

    <ResourceTools />
  </ul>
</template>
